/**
 * Error IDs for Sentry tracking and correlation.
 *
 * Use these IDs in captureException calls to:
 * - Track error frequency by type
 * - Group related errors in Sentry
 * - Set up alerts for specific error conditions
 * - Debug patterns across multiple error instances
 *
 * Format: <component>-<sequence>
 */
export const ERROR_IDS = {
  // Sidebar hover overlay errors
  SIDEBAR_HOVER_BACKGROUND_CLICK_FAILED: 'sidebar-001',
  SIDEBAR_HOVER_CLICK_OUTSIDE_FAILED: 'sidebar-002',
  SIDEBAR_HOVER_MOUSE_ENTER_FAILED: 'sidebar-003',
  SIDEBAR_HOVER_MOUSE_LEAVE_FAILED: 'sidebar-004',

  // User preferences store errors
  USER_PREFERENCES_LOAD_FAILED: 'preferences-001',
  USER_PREFERENCES_SAVE_FAILED: 'preferences-002',

  // Organization switcher store errors
  ORG_SWITCHER_OPERATION_FAILED: 'org-switcher-001',

  // UserDropdown errors
  USER_DROPDOWN_OPERATION_FAILED: 'user-dropdown-001',

  // WorkspaceSwitcher errors
  WORKSPACE_SWITCHER_OPERATION_FAILED: 'workspace-switcher-001',
} as const;

export type ErrorId = (typeof ERROR_IDS)[keyof typeof ERROR_IDS];
